import React from 'react';
import { Routes, Route, HashRouter } from 'react-router-dom';
import { SignupPage } from './pages/SignUp';
import { AboutPage } from './pages/AboutPage';
import { HomePage } from './pages/HomePage';
import { SearchPage } from './pages/Search';

function App() {
  React.useEffect(() => {
      document.title = "True Searcher"
  })

  return (
    <div>
      <HashRouter>
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/signup' element={<SignupPage />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;